module.exports = __webpack_public_path__ + "static/media/arrowDown.6c8574a1.svg";